import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { IModelBase } from 'common-components'
import { ODataService } from 'common-services'

export interface IEpisodeType extends IModelBase {
  Name: string
}

@Injectable()
export class EpisodeTypeODataService extends ODataService<IEpisodeType> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'EpisodeTypes'
  }
}
